<dx-popup
  #preferencesPopup
  width="380px"
  height="auto"
  [showTitle]="false"
  [showCloseButton]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [shading]="true"
  [(visible)]="preferencesVisible"
  (onHiding)="onCancelClick()"
  (onShown)="repaint()"
>
  <div *dxTemplate="let data of 'content'" class="preferences-popup">
    <!-- Header -->
    <div class="preferences-popup__header">
      <span class="preferences-popup__title">Preferences</span>
      <button
        class="preferences-popup__close"
        (click)="onCancelClick()"
        aria-label="Close"
      >
        <app-icon name="close" size="13px" stroke="#121F38"></app-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="preferences-popup__body">
      <div class="preferences-popup__field">
        <label class="preferences-popup__label">Time Zone</label>
        <dx-select-box
          [items]="timeZones"
          [searchMode]="'contains'"
          [searchEnabled]="true"
          [(value)]="selectedTimeZoneName"
        ></dx-select-box>
      </div>
      <div class="preferences-popup__field">
        <label class="preferences-popup__label">Rounding</label>
        <dx-number-box
          [(value)]="selectedPrecision"
          [min]="0"
          [max]="4"
          [showSpinButtons]="true"
        ></dx-number-box>
      </div>
    </div>

    <!-- Footer -->
    <div class="preferences-popup__footer">
      <button class="pref-btn pref-btn--cancel" (click)="onCancelClick()">
        Cancel
      </button>
      <button class="pref-btn pref-btn--apply" (click)="onApplyClick()">
        Apply
      </button>
    </div>
  </div>
</dx-popup>
